import * as Fingerprint from 'fingerprintjs';

export function getBrowserFingerprint(): number {
  return new Fingerprint().get();
}
